import React from "react"
import propTypes from "prop-types"

const Label = ({ children }) => {
  return <div className="info-card_label">{children}</div>
}

Label.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired
}

export default Label
